/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { DynamicFormControlLayout } from '../../../model/misc/dynamic-form-control-layout.model'
import { DynamicRadioGroupModel } from '../../../model/radio/dynamic-radio-group.model'
import { DynamicFormLayout, DynamicFormLayoutService } from '../../../service/dynamic-form-layout.service'
import { DynamicFormValidationService } from '../../../service/dynamic-form-validation.service'
import { BaseFormControlComponent } from '../base-form-control.component'

@Component({
  selector: 'dynamic-basic-radio-group',
  templateUrl: './dynamic-basic-radio-group.component.html',
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DynamicBasicRadioGroupComponent extends BaseFormControlComponent {
  // @ts-ignore
  layoutService: DynamicFormLayoutService
  // @ts-ignore
  validationService: DynamicFormValidationService

  // @ts-ignore
  @Input() formLayout: DynamicFormLayout
  // @ts-ignore
  @Input() group: UntypedFormGroup
  // @ts-ignore
  @Input() layout: DynamicFormControlLayout
  // @ts-ignore
  @Input() model: DynamicRadioGroupModel<string>

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus: EventEmitter<any> = new EventEmitter()

  constructor() {
    const layoutService = inject(DynamicFormLayoutService)
    const validationService = inject(DynamicFormValidationService)

    super()

    this.layoutService = layoutService
    this.validationService = validationService
  }
}
